import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  exportSources: {
    position: 'fixed',
    display: 'grid',
    gap: '6px',
    top: 'calc(var(--header-h) + 12px)',
    right: '12px',

    '@media screen and (min-width: 1441px)': {
      gap: '8px',
      top: 'calc(var(--header-h) + 16px)',
      right: '16px',
    },
  },
}));

export default useStyles;
